/**
 * Exercise prescription types and labels (aligned with mobile/shared).
 */
export const ExercisePrescriptionTypes = Object.freeze({
  REPETITION: "repetition",
  DURATION: "duration",
  DISTANCE: "distance",
  INTERVAL: "interval",
});

export const ExercisePrescriptionLabels = {
  [ExercisePrescriptionTypes.REPETITION]: "Reps / Sets",
  [ExercisePrescriptionTypes.DURATION]: "Duration",
  [ExercisePrescriptionTypes.DISTANCE]: "Distance",
  [ExercisePrescriptionTypes.INTERVAL]: "Intervals (HIIT)",
};

export const DEFAULT_EXERCISE_PRESCRIPTION_TYPE =
  ExercisePrescriptionTypes.REPETITION;
